module.exports = __webpack_public_path__ + "img/communities.1eebed24.png";